import React from 'react';
import Modal from './ui/Modal.jsx';

const HowToPlayModal = ({ onClose }) => {
    return (
        <Modal title="How to Play: Verbatim Master" onClose={onClose} size="md">
            <div className="space-y-3 text-slate-200">
                <p><strong>The Goal:</strong> Prove you're a master of recall! Your mission is to listen to the question and then speak the answer exactly as it appears on the flashcard.</p>
                <h3 className="font-semibold text-white">Gameplay</h3>
                <ol className="list-decimal pl-5 space-y-1">
                    <li><strong>Listen Carefully:</strong> A question from your deck will be read aloud.</li>
                    <li><strong>Speak Clearly:</strong> After the question, the microphone will activate. Speak the answer clearly and precisely. Recording stops after a moment of silence.</li>
                    <li><strong>Get Scored:</strong> Verbatim Master will instantly score your answer based on how close it is to the correct one.</li>
                </ol>
                <h3 className="font-semibold text-white">Scoring & Ranks</h3>
                <ul className="list-disc pl-5 space-y-1">
                    <li><strong>Verbatim Master (100%):</strong> 🏆 Flawless recall!</li>
                    <li><strong>Synapse Slayer (90-99%):</strong> 🧠 A truly elite memory.</li>
                    <li><strong>Recall Assassin (80-89%):</strong> 🗡️ Sharp and deadly accurate.</li>
                    <li><strong>Mind Sniper (70-79%):</strong> 🎯 On target, but aim for perfection.</li>
                    <li><strong>Mnemonic Casualty (<span className="align-[0.05em]">&lt;</span>70%):</strong> 🩹 A valiant effort. Review and try again!</li>
                </ul>
                <h3 className="font-semibold text-white">The Benefit</h3>
                <p>This isn't just a game; it's a powerful study tool. Recalling information verbatim strengthens neural pathways, dramatically improving your long-term memory and mastery of the subject.</p>
            </div>
            <div className="mt-6 flex justify-end">
                <button onClick={onClose} className="rounded-xl px-4 py-2 text-sm text-white bg-gradient-to-r from-teal-600 to-emerald-600">Got It!</button>
            </div>
        </Modal>
    );
};

export default HowToPlayModal;


